import { render, staticRenderFns } from "./TerminDozenteneinsatzUpdateModal.vue?vue&type=template&id=49a36d24"
import script from "./TerminDozenteneinsatzUpdateModal.vue?vue&type=script&lang=js"
export * from "./TerminDozenteneinsatzUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports